import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AppConfig } from 'src/app/app.config';

const TENANT_ID = '2';

const getTenantId = (): string => {
  const configuredTenantId = AppConfig.appsettings?.tenantId;

  if (configuredTenantId) {
    return configuredTenantId;
  }

  const document = inject(DOCUMENT);
  const appRootElement = document.querySelector('app-root');
  return appRootElement?.getAttribute('tenantId') ?? '';
};

export const tenantHomeMatchGuard: CanMatchFn = () => {
  return getTenantId() === TENANT_ID;
};

export const nonTenantHomeMatchGuard: CanMatchFn = () => {
  return getTenantId() !== TENANT_ID;
};